export default __webpack_public_path__ + "static/media/pergola_edit.7a4405c1.jpg";